import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=2a9a8628&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=2a9a8628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a8628",
  null
  
)

export default component.exports